// This import loads the firebase namespace along with all its type information.
import History from './history-model'

export async function load_historys(): Promise<History[]> {
  throw 'Not implemented'
}

export async function delete_history(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_history(): Promise<History> {
  throw 'Not implemented'
}
